/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import microApp from '@micro-zoe/micro-app';
import { useEffect } from 'react';
// import { MicroAppActionType } from './const';
// import { microAppUnmount } from './utils';
export default function StyleEditorMicroApp(props) {
  const { onMounted, onUnmounted, onMicroAppMessage, name, env } = props;
  useEffect(() => {
    return () => {
      // 先清空数据，再卸载应用
      microApp.setData(name, { appConfig: {} });
      microApp.clearData(name);
      microApp
        .unmountApp(name, {
          destroy: true,
          clearAliveState: true,
          clearData: true,
        })
        .then(() => onUnmounted?.());
    };
  }, []);
  const handleDataChange = e => {
    const data = e?.detail?.data || {};
    console.log('子应用传递的数据：', data);
    onMicroAppMessage?.(data);
    // 移除微应用执行关闭事件卸载编辑器的处理
    // setTimeout(() => {
    //   if (data.type === MicroAppActionType.CLOSE) {
    //     microAppUnmount(name);
    //   }
    // }, 500);
  };
  const handleMount = () => {
    console.log('子应用已经渲染完成');
    onMounted?.();
  };

  window.__STYLE_EDITOR_ENV__ = env;

  const ts = localStorage.getItem('microAppTs');
  const base = `${window.location.origin}/style-editor/index.html`;
  return jsxCustomEvent('micro-app-style-editor', {
    name: name,
    url: `${base}?t=${ts}`,
    onDataChange: handleDataChange,
    onMounted: handleMount,
    iframe: true,
    style: { width: '100%', height: '100%' },
  });
}
